(ns impersonate.events
  (:require
   [very.re-frame.core :as rf]
   [graphql.core :as qu]))

(def reroute {"advisor" "/dashboard"
              "personal-gameplan" "/personal-gameplan"})

(rf/reg-event-fx
  :impersonate/identify-session
  (fn [cfx [loc]]
    (let [k (last (:paths loc))
          err (:current loc)
          suc (get reroute (first (:paths loc)))]
      {:graphql {:gql (qu/impersonate {:identifier-key k})
                 :success [:impersonate/identifiable suc]
                 :error [:impersonate/unidentifiable err]
                 :failure [:impersonate/unidentifiable err]
                 :allow-unauth? true}})))

(rf/reg-event-fx
  :impersonate/identifiable
  (fn [cfx [nxt data]]
    (let [token (get-in data [:impersonate :session :token])]
      {:session [:set [:token token]]
       :db (assoc (:db cfx) :impersonate/token token)
       :dispatch [:validate-session nxt]})))

(rf/reg-event-fx
  :impersonate/unidentifiable
  (fn [cfx [nxt]]
    {:nav! nxt}))

(rf/reg-sub
  :impersonate/token
  (fn [db]
    (:impersonate/token db)))
